import { useRef } from 'react'

export const useStableList = <T>(list: T[]): T[] => {
  const stableRef = useRef(list)
  const current = stableRef.current
  const isEqual =
    current === list ||
    (current.length === list.length && current.every((item, index) => item === list[index]))

  if (!isEqual) stableRef.current = list

  return stableRef.current
}
